import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'grades',
    pluginName: 'SETTINGS',
    entityName: 'GRADE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch grades action creators
export const fetchGradesInit = () => {
    return crudActions.fetchInit();
};
export const fetchGradeStart = () => {
    return crudActions.fetchStart();
};
export const fetchGradeSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchGradeFail = () => {
    return crudActions.fetchFail();
};
export const fetchGradeCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let countRes = await rest.post("grades/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch grades."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch grades."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchGrade = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let listRes = await rest.post("grades/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data
            }
            return []

        } catch (error) {
            return []
        }
    }
}

// Load grade action creators
export const loadGradeInit = () => {
    return crudActions.loadInit();
};
export const loadGradeStart = () => {
    return crudActions.loadStart();
};
export const loadGradeSuccess = loadedGrade => {
    return crudActions.loadSuccess(loadedGrade);
};
export const loadGradeFail = error => {
    return crudActions.loadFail(error);
};
export const loadGrade = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create grade action creators
export const createGradeInit = () => {
    return crudActions.createInit();
};
export const createGradeStart = () => {
    return crudActions.createStart();
};
export const createGradeSuccess = createdGrade => {
    return crudActions.createSuccess(createdGrade);
};
export const createGradeFail = error => {
    return crudActions.createFail(error);
};

export const createGrade = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createGradeStart());
        try {
            let res = await rest.post('/grades/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created grade.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createGradeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create grade."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create grade."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createGradeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit grade action creators
export const editGradeInit = () => {
    return crudActions.editInit();
};
export const editGradeStart = () => {
    return crudActions.editStart();
};
export const editGradeSuccess = editedGrade => {
    return crudActions.editSuccess(editedGrade);
};
export const editGradeFail = error => {
    return crudActions.editFail(error);
};

export const editGrade = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editGradeStart());
        try {
            let res = await rest.post('/grades/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated grade.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editGradeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit grade."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit grade."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editGradeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete grades action creators
export const bulkDeleteGradesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteGradesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteGradesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteGradesFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteGrades = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteGradesStart());
        try {
            let res = await rest.post('/grades/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteGradesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted grades.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteGradesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete grades."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete grades."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteGradesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const editGradeVisibility = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grades/update-visibility', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated grade visibility.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot update grade visibility."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const bulkVisibilityEditGrades = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grades/bulk-visibility-update', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated visibility of grades.`,
                    options: {
                        variant: 'success'
                    }
                });
                return;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot update visibility of grades."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};